import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { CADClassificationDraft } from './classification';

interface CADClassificationFieldsProps {
  value: CADClassificationDraft;
  onChange: (value: CADClassificationDraft) => void;
  idPrefix: string;
  disabled?: boolean;
}

const CADClassificationFields: React.FC<CADClassificationFieldsProps> = ({
  value,
  onChange,
  idPrefix,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const field = (
    key: keyof CADClassificationDraft,
    label: string,
    placeholder: string,
    maxLength: number,
  ) => (
    <div className={key === 'folderPath' || key === 'tagsText' ? 'col-span-2' : ''}>
      <Label htmlFor={`${idPrefix}-${key}`} className="text-xs">{label}</Label>
      <Input
        id={`${idPrefix}-${key}`}
        value={value[key]}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onChange={(event) => onChange({ ...value, [key]: event.target.value })}
      />
    </div>
  );

  return (
    <div className="grid grid-cols-2 gap-2">
      {field(
        'folderPath',
        t('cad.classification.folder'),
        t('cad.classification.folderPlaceholder'),
        200,
      )}
      {field(
        'machineModel',
        t('cad.classification.machineModel'),
        t('cad.classification.machineModelPlaceholder'),
        100,
      )}
      {field(
        'managementNumber',
        t('cad.classification.managementNumber'),
        t('cad.classification.managementNumberPlaceholder'),
        100,
      )}
      {field(
        'tagsText',
        t('cad.classification.tags'),
        t('cad.classification.tagsPlaceholder'),
        1019,
      )}
      <p className="col-span-2 text-[11px] leading-relaxed text-muted-foreground">
        {t('cad.classification.help')}
      </p>
    </div>
  );
};

export default CADClassificationFields;
